var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-migration"},[_c('introduce'),_c('instructions'),_c('serverList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }